import React from 'react';
import CopyButton from './CopyButton';
import { PAYMENT_WHATSAPP_DISPLAY } from './paymentContactInfo';

// How to pay: contact customer service on WhatsApp. Reused by the payment
// banner and the login payment-blocked card.
function PaymentMethodInfo() {
  return (
    <div>
      <div style={{ fontSize: 14, color: '#111827', lineHeight: 1.5, marginBottom: 8 }}>
        Contactate con atención al cliente por WhatsApp para coordinar el pago.
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 12,
          padding: '8px 0',
        }}
      >
        <div>
          <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 2 }}>WhatsApp de atención al cliente</div>
          <div style={{ fontSize: 14, color: '#111827', fontWeight: 600 }}>{PAYMENT_WHATSAPP_DISPLAY}</div>
        </div>
        <CopyButton value={PAYMENT_WHATSAPP_DISPLAY} label="Copiar" />
      </div>
    </div>
  );
}

export default PaymentMethodInfo;
